import { render } from "./ui-products.vue?vue&type=template&id=78beff6a"
import script from "./ui-products.vue?vue&type=script&lang=js"
export * from "./ui-products.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__